import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

import API from 'utils/api';
import { useSources, useValueChangeEffect } from 'hooks';
import { classes } from 'utils';

import styles from './LeagueTeamFilter.module.scss';

const LeagueTeamFilter = props => {
  const [leagues, setLeagues] = useState([]);
  const [teams, setTeams] = useState([]);
  const [values, setValues] = useState(
    _.pickBy(props, (value, key) => value && (key === 'leagueId' || key === 'teamId'))
  );

  const sources = useSources();

  const query = props.query ? JSON.stringify(props.query) : undefined;
  const { direction = 'row', disabled, teamFilter = true } = props;

  useEffect(() => {
    sources.cancelAll('getLeagues');

    API.getLeagues(
      { ignoreDependencies: true, query, select: 'name', sort: 'name' },
      sources,
      'getLeagues'
    ).then(({ data }) => (data && data.docs ? setLeagues(data.docs) : null));
  }, [sources, query, props.leagueId]);

  useEffect(() => {
    if (teamFilter) {
      if (values.leagueId) {
        sources.cancelAll('getTeams');
        setTeams(null);

        API.getTeams(
          {
            ignoreDependencies: true,
            query: JSON.stringify({ leagues: values.leagueId }),
            select: 'name',
            sort: 'name',
          },
          sources,
          'getTeams'
        ).then(({ data }) => (data && data.docs ? setTeams(data.docs) : null));
      } else {
        setTeams([]);
      }
    }
  }, [sources, values.leagueId, teamFilter]);

  useValueChangeEffect(values, props.onChange);

  const renderSelect = (title, value, options, onChange, disabled) => (
    <FormControl style={{ width: '100%' }}>
      <InputLabel>{title}</InputLabel>

      <Select
        value={value && options.find(it => it._id === value) ? value : ''}
        onChange={event => onChange(event.target.value)}
        disabled={disabled}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>

        {options.map(({ _id, name }) => (
          <MenuItem key={_id} value={_id}>
            <div
              style={{
                display: 'block',
                width: '100%',
                textAlign: 'center',
              }}
            >
              {name}
            </div>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  return (
    <div className={classes(styles.filter, styles[direction])}>
      <div className={styles.league}>
        {renderSelect(
          'League',
          values.leagueId,
          leagues,
          val => setValues(val ? { leagueId: val } : {}),
          disabled
        )}
      </div>

      {teamFilter ? (
        <div className={styles.team}>
          {renderSelect(
            'Team',
            values.teamId,
            teams || [],
            teamId =>
              setValues(({ leagueId }) => (teamId ? { leagueId, teamId } : { leagueId })),
            disabled || !values.leagueId || !teams
          )}
        </div>
      ) : null}
    </div>
  );
};

export default LeagueTeamFilter;
